import React, { Dispatch, ReactNode, SetStateAction } from 'react';
import { TablePagination } from 'global';
import { Box, Button } from '@mui/material';
import { Refresh } from '@mui/icons-material';
import { Listing } from 'components/shared/TableListing';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';

import { ChangelogFilters } from './ChangelogFilters';
import { ChangelogFiltersInput, ChangelogTableRow } from './types';

import { getChangelogListingColumns } from './listingConfig';

interface Props<ResponseListItem> {
  total?: number;
  loading: boolean;
  refetch: () => void;
  list: ResponseListItem[];
  pagination: TablePagination;
  changesCell: (row: ChangelogTableRow) => ReactNode;
  mapper: (list: ResponseListItem[]) => ChangelogTableRow[];
  onPaginationChanged: Dispatch<SetStateAction<TablePagination>>;
  onFiltersChanged: (nextFilters: ChangelogFiltersInput | undefined) => void;
}

export const ChangelogListing = <ResponseListItem,>({
  mapper,
  list,
  refetch,
  loading,
  total = 0,
  pagination,
  changesCell,
  onFiltersChanged,
  onPaginationChanged,
}: Props<ResponseListItem>) => {
  const tableData: ChangelogTableRow[] = mapper(list);

  return (
    <CardContainer
      title="List"
      style={{ overflow: 'hidden' }}
      actionBtn={
        <Button startIcon={<Refresh />} onClick={() => refetch()} disabled={loading}>
          Update
        </Button>
      }
    >
      <Box sx={{ gap: '1rem', minHeight: 0, display: 'flex', height: '100%', flexDirection: 'column' }}>
        <ChangelogFilters loading={loading} onFiltersChanged={onFiltersChanged} />

        <Box sx={{ flex: 1, minHeight: 0, height: 0 }}>
          <Listing<ChangelogTableRow>
            maxHeight="100%"
            loading={loading}
            tableData={tableData}
            columns={getChangelogListingColumns(changesCell)}
            pagination={{
              ...pagination,
              total,
              onChange: nextValue => onPaginationChanged(prev => ({ ...prev, page: nextValue })),
            }}
          />
        </Box>
      </Box>
    </CardContainer>
  );
};
